import { render, staticRenderFns } from "./DomainSettings.vue?vue&type=template&id=2c8c91b8&"
import script from "./DomainSettings.vue?vue&type=script&lang=js&"
export * from "./DomainSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports